import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Card, Typography, Stack, Box, Skeleton } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { getOverView } from '../../../../../redux/features/poinTrackerSlice';

export const DailyRevenueCard = ({ fromDate, toDate, selectedTeam }) => {
  const dispatch = useDispatch();
  const { loading, responseData } = useSelector((state) => state.pointTracker.overView);
  const dispatchParams = useMemo(() => {
    return {
      fromDate,
      toDate,
      wingId: selectedTeam?.id === -1 ? null : selectedTeam?.id,
    };
  }, [fromDate, toDate, selectedTeam?.id]);

  useEffect(() => {
    if (fromDate && toDate) {
      dispatch(getOverView(dispatchParams));
    }
  }, [dispatch, dispatchParams]);

  const cardsOverview = responseData?.data?.dailyPulse || {};
  const noData =
    !loading &&
    (!cardsOverview ||
      Object.keys(cardsOverview).length === 0 ||
      (cardsOverview?.revenue?.value == null && cardsOverview?.admissions?.value == null));
  return (
    <Card
      sx={{
        p: 3,
        mt: 2,
        borderRadius: 2,
        bgcolor: '#eff6ff', // Light blue background
        border: '1px solid #9cbeeb',
        width: '100%',
      }}
    >
      {loading ? (
        <>
          {/* Title */}
          <Skeleton width="40%" height={20} animation="wave" />

          {/* Revenue */}
          <Skeleton width="60%" height={50} animation="wave" sx={{ my: 1 }} />

          {/* Stats Row */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Skeleton variant="circular" width={20} height={20} animation="wave" />
              <Skeleton width={40} height={20} animation="wave" />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Skeleton variant="circular" width={20} height={20} animation="wave" />
              <Skeleton width={60} height={20} animation="wave" />
            </Box>
          </Stack>
        </>
      ) : noData ? (
        <Box
          sx={{
            height: '150px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography color="text.secondary">No Data Found</Typography>
        </Box>
      ) : (
        <>
          <Typography variant="subtitle1" fontWeight="bold" color="#1e293b">
            Daily Revenue
          </Typography>

          <Typography variant="h3" fontWeight="800" sx={{ color: '#2563eb', my: 1 }}>
            {cardsOverview?.revenue?.value}
          </Typography>

          <Stack direction="row" spacing={2} alignItems="center">
            <Box sx={{ display: 'flex', alignItems: 'center', color: '#10b981', gap: 0.5 }}>
              <ArrowUpwardIcon fontSize="small" />
              <Typography variant="body2" fontWeight="bold">
                {cardsOverview?.revenue?.trend}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', color: '#10b981', gap: 0.5 }}>
              <TrendingUpIcon fontSize="small" />
              <Typography variant="body2" fontWeight="bold">
                {cardsOverview?.admissions?.trend}
              </Typography>
            </Box>
          </Stack>
        </>
      )}
    </Card>
  );
};
